const Logger = {
  log: (message, ...args) => {
    if(args) {
      console.log(message,...args);
    }
    else{
      console.log(message);
    }
  }
};

export default Logger;
